import React, {useEffect, useState} from 'react';
import {Modal, ModalBody} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    getNotesArray,
    getNotesLoading,
    getNotesModalStatus,
    getNotesPagination,
    getUserInfo
} from "../../../redux-store/selectors";
import {
    createNote,
    deleteNote,
    getNotes,
    setDeleteModalStatus,
    setModalStatus,
    updateNote
} from "../../../redux-store/notes";
import {Pagination, Table, Tooltip} from "antd";
import {useForm} from "react-hook-form";
import {REQUIRED_FIELD} from "../../../constants/Messages";
import {timeStampToTimeString} from "../../../constants/FunctionJS";
import editIcon from "../../../images/Group 28.svg";
import trashIcon from "../../../images/bin.svg";
import NotesConfirmationModal from "./NotesConfirmationModal";
import {checkUserViewer} from "../../authHelpers";

const LocationNotes = ({installationId, locationId}) => {

    const dispatch = useDispatch();
    const modalVisibility = useSelector(getNotesModalStatus);
    const userInfo = useSelector(getUserInfo)

    const notes = useSelector(getNotesArray);
    const loading = useSelector(getNotesLoading);
    const {total, currentPage, pageSize} = useSelector(getNotesPagination);

    const [editId, setEditId] = useState(null);
    const [deleteId, setDeleteId] = useState(null);

    const {
        handleSubmit,
        formState: {},
        register,
        setValue
    } = useForm();

    const onModalClose = () => {
        dispatch(setModalStatus(false));
    }
    useEffect(() => {
        dispatch(getNotes({installationId, locationId}))
    }, []);
    const onEdit = item => {
        setEditId(item.id);
        setValue("comment", item.comment)
    }
    const onDelete = item => {
        setDeleteId(item);
        setEditId(null);
        setValue("comment", item.comment)
        dispatch(setDeleteModalStatus(true));
    }
    const tableHeader = [
        {
            title: <Tooltip title="Korisnik"><span>Korisnik</span></Tooltip>,
            dataIndex: "username",
            key: "id",
        },
        {
            title: <Tooltip title="Vrijeme"><span>Vrijeme</span></Tooltip>,
            dataIndex: "time",
            key: "id",
            render: (cell, row) => timeStampToTimeString(cell)
        },
        {
            title: <Tooltip title="Poruka"><span>Poruka</span></Tooltip>,
            dataIndex: "comment",
            key: "id",
        },
        {
            title: <Tooltip title="Akcije"><span>Akcije</span></Tooltip>,
            dataIndex: "id",
            key: "id",
            render: (item, row) => {

                return <>
                    <img src={editIcon} alt={"Edit Icon"} onClick={() => onEdit(row)}
                         className={"m-right cursor-button"}/>
                    <img src={trashIcon} alt={"Trash Icon"} onClick={() => onDelete(row.id)}
                         className={"w-icons cursor-button"}/>
                </>
            }
        },
    ]
    const onsubmit = data => {
        if (editId !== null)
            dispatch(updateNote({
                installationId,
                locationId,
                noteId: editId,
                data
            }))
        else
            dispatch(createNote({
                installationId,
                locationId,
                data
            }))
    }

    const mapHeader = (header) => {
        return header.map((header) => {
            if (checkUserViewer(userInfo) && header.dataIndex === "id") {
                return {}
            } else {
                return header
            }
        }).filter((item) => Object.keys(item).length > 0)
    }

    const onEditCancel = () => {
        setEditId(null);
        setValue("comment", "");
    }
    const deleteConfirmation = () => {
        dispatch(deleteNote({
            installationId,
            locationId,
            noteId: deleteId,
        }))
    }
    return (
        <Modal
            show={modalVisibility}
            onHide={onModalClose}
            backdrop="static"
            keyboard={false}
            size={"xl"}
        >
            <Modal.Header closeButton className={"modal-header-component"}>
                <Modal.Title>Bilješke</Modal.Title></Modal.Header>
            <ModalBody>
                <NotesConfirmationModal onSubmit={deleteConfirmation}/>
                {checkUserViewer(userInfo) ? "" : <div className={"d-flex justify-content-end align-items-center"}>
                    <form onSubmit={handleSubmit(onsubmit)}>
                        <input type="text" className={"form-control notes-input"}
                               placeholder={"Unesi poruku"} {...register("comment", {required: REQUIRED_FIELD})}/>
                    </form>
                    {editId !== null &&
                        <button onClick={onEditCancel} className={"btn btn-modal-cancel btn-notes-cancel ms-2"}>Otkaži
                            izmjenu</button>}
                    <button className={"btn btn-modal-confirm"} onClick={handleSubmit(onsubmit)}
                            style={{padding: "7px 20px"}}>
                        {editId !== null ? "Izmijeni" : "Kreiraj"}
                    </button>
                </div>}
                <div className={"row pt-2 pb-2 alarm-table"}>
                    <Table showSorterTooltip={false} columns={mapHeader(tableHeader)} dataSource={notes}
                           size="middle"
                           scroll={{
                               x: 900,
                               y: 350,
                           }}
                           loading={loading}
                           pagination={false}
                    />
                    {total !== 0 && <div className={"row text-right pt-2 pb-4"}>
                        <Pagination defaultCurrent={1}
                                    current={currentPage + 1}
                                    total={total}
                                    showSizeChanger={false}
                                    onChange={(newPage, newPageSize) => {
                                        dispatch(getNotes({installationId, locationId, page: newPage - 1}))
                                    }}
                                    defaultPageSize={pageSize}
                        />
                    </div>}
                </div>
            </ModalBody>
        </Modal>
    );
};

export default LocationNotes;